import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            pageTitle: 'Home',
            authRequired: true,
          },
        },
        // {
        //   path: '/page2',
        //   name: 'page-2',
        //   component: () => import('./views/Page2.vue'),
        // },
        // =============================================================================
        // Collection Routes
        // =============================================================================
        {
          path: '/collection',
          name: 'collection',
          component: () => import('./views/collection/CollectionList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Collection' }, { title: 'List', active: true }],
            pageTitle: 'Collection',
            authRequired: true,
          },
        },
        {
          path: '/collection/add',
          name: 'collection-add',
          component: () => import('./views/collection/CollectionForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Collection', url: '/collection' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Collection',
            authRequired: true,
          },
        },
        {
          path: '/collection/:id',
          name: 'collection-edit',
          component: () => import('./views/collection/CollectionForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Collection', url: '/collection' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Collection',
            authRequired: true,
          },
        },
        // =============================================================================
        // Product Routes
        // =============================================================================
        {
          path: '/product',
          name: 'product',
          component: () => import('./views/product/ProductList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Product' }, { title: 'List', active: true }],
            pageTitle: 'Product',
            authRequired: true,
          },
        },
        {
          path: '/product/add',
          name: 'product-add',
          component: () => import('./views/product/ProductForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product', url: '/product' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Product',
            authRequired: true,
          },
        },
        {
          path: '/product/:id',
          name: 'product-edit',
          component: () => import('./views/product/ProductForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Product', url: '/product' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Product',
            authRequired: true,
          },
        },
        // =============================================================================
        // Product Review Routes
        // =============================================================================
        {
          path: '/review',
          name: 'review',
          component: () => import('./views/review/ReviewList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Review' }, { title: 'List', active: true }],
            pageTitle: 'Review',
            authRequired: true,
          },
        },
        // =============================================================================
        // Newsletter Routes
        // =============================================================================
        {
          path: '/newsletter',
          name: 'newsletter',
          component: () => import('./views/newsletter/NewsletterList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Newsletter' }, { title: 'List', active: true }],
            pageTitle: 'Newsletter',
            authRequired: true,
          },
        },
        {
          path: '/newsletter/add',
          name: 'newsletter-add',
          component: () => import('./views/newsletter/NewsletterForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletter', url: '/newsletter' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Newsletter',
            authRequired: true,
          },
        },
        {
          path: '/newsletter/:id',
          name: 'newsletter-edit',
          component: () => import('./views/newsletter/NewsletterForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Newsletter', url: '/newsletter' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Newsletter',
            authRequired: true,
          },
        },
        // Widget Routes
        // =============================================================================
        {
          path: '/widget',
          name: 'widget',
          component: () => import('./views/widget/WidgetList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Widget' }, { title: 'List', active: true }],
            pageTitle: 'Widget',
            authRequired: true,
          },
        },
        {
          path: '/widget/add',
          name: 'widget-add',
          component: () => import('./views/widget/WidgetForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Widget', url: '/widget' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Widget',
            authRequired: true,
          },
        },
        {
          path: '/widget/:id',
          name: 'widget-edit',
          component: () => import('./views/widget/WidgetForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Widget', url: '/widget' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Widget',
            authRequired: true,
          },
        },
        // Faq Routes
        // =============================================================================
        {
          path: '/faq',
          name: 'faq',
          component: () => import('./views/faq/FaqList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'FAQ' }, { title: 'List', active: true }],
            pageTitle: 'FAQ',
            authRequired: true,
          },
        },
        {
          path: '/faq/add',
          name: 'faq-add',
          component: () => import('./views/faq/FaqForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FAQ', url: '/faq' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add FAQ',
            authRequired: true,
          },
        },
        {
          path: '/faq/:id',
          name: 'faq-edit',
          component: () => import('./views/faq/FaqForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'FAQ', url: '/faq' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit FAQ',
            authRequired: true,
          },
        },
        // Latest Videos Routes
        // =============================================================================
        {
          path: '/latest-video',
          name: 'latest-video',
          component: () => import('./views/latest-video/LatestVideoList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Latest Video' }, { title: 'List', active: true }],
            pageTitle: 'Latest Video',
            authRequired: true,
          },
        },
        {
          path: '/latest-video/add',
          name: 'latest-video-add',
          component: () => import('./views/latest-video/LatestVideoForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Latest Video', url: '/latest-video' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Latest Video',
            authRequired: true,
          },
        },
        {
          path: '/latest-video/:id',
          name: 'latest-video-edit',
          component: () => import('./views/latest-video/LatestVideoForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Latest Video', url: '/latest-video' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Latest Video',
            authRequired: true,
          },
        },
        // Advisor Routes
        // =============================================================================
        {
          path: '/advisor',
          name: 'advisor',
          component: () => import('./views/advisor/AdvisorList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Advisor' }, { title: 'List', active: true }],
            pageTitle: 'Advisor',
            authRequired: true,
          },
        },
        {
          path: '/advisor/add',
          name: 'advisor-add',
          component: () => import('./views/advisor/AdvisorForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advisor', url: '/advisor' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Advisor',
            authRequired: true,
          },
        },
        {
          path: '/advisor/:id',
          name: 'advisor-edit',
          component: () => import('./views/advisor/AdvisorForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advisor', url: '/Advisor' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Advisor',
            authRequired: true,
          },
        },
        {
          path: '/advisor/:id/appointment-config',
          name: 'advisor-appointment-config',
          component: () => import('./views/advisor/AdvisorAppointmentConfig.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advisor', url: '/Advisor' },
              { title: 'Appointment Config', active: true },
            ],
            pageTitle: 'Appointment Config',
            authRequired: true,
          },
        },
        // Discovery Routes
        // =============================================================================
        {
          path: '/discovery',
          name: 'discovery',
          component: () => import('./views/useful-link/UsefulLinkList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Discovery' }, { title: 'List', active: true }],
            pageTitle: 'Discovery',
            authRequired: true,
            category: 'discovery'
          }
        },
        {
          path: '/discovery/add',
          name: 'discovery-add',
          component: () => import('./views/useful-link/UsefulLinkForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Discovery', url: '/discovery' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Discovery',
            authRequired: true,
            category: 'discovery'
          }
        },
        {
          path: '/discovery/:id',
          name: 'discovery-edit',
          component: () => import('./views/useful-link/UsefulLinkForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Discovery', url: '/discovery' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Discovery',
            authRequired: true,
            category: 'discovery'
          }
        },
        // =============================================================================
        // Admin Routes
        // =============================================================================
        {
          path: '/admin',
          name: 'admin',
          component: () => import('./views/admin/AdminList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Admin' }, { title: 'List', active: true }],
            pageTitle: 'Admin',
            authRequired: true,
          },
        },
        {
          path: '/admin/add',
          name: 'admin-add',
          component: () => import('./views/admin/AdminForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admin', url: '/admin' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Admin',
            authRequired: true,
          },
        },
        {
          path: '/admin/:id',
          name: 'admin-edit',
          component: () => import('./views/admin/AdminForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admin', url: '/admin' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Admin',
            authRequired: true,
          },
        },
        // =============================================================================
        // User Routes
        // =============================================================================
        {
          path: '/user',
          name: 'user',
          component: () => import('./views/user/UserList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'User' }, { title: 'List', active: true }],
            pageTitle: 'User',
            authRequired: true,
          },
        },
        {
          path: '/user/add',
          name: 'user-add',
          component: () => import('./views/user/UserForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User', url: '/user' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'User',
            authRequired: true,
          },
        },
        {
          path: '/user/:id',
          name: 'user-edit',
          component: () => import('./views/user/UserForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User', url: '/user' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'User',
            authRequired: true,
          },
        },
        // =============================================================================
        // Purchases Routes
        // =============================================================================
        {
          path: '/purchase',
          name: 'purchase',
          component: () => import('./views/purchase/PurchaseList.vue'),
          meta: {
            breadcrumb: [{ title: 'Purchase', url: '/' }, { title: 'Purchase' }, { title: 'List', active: true }],
            pageTitle: 'Purchase',
            authRequired: true,
          },
        },
        {
          path: '/purchase/:id',
          name: 'purchase-detail',
          component: () => import('./views/purchase/PurchaseDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Purchase', url: '/purchase' },
              { title: 'Detail', active: true },
            ],
            pageTitle: 'Purchase',
            authRequired: true,
          },
        },
        // =========================================================================
        // PROFILE PAGES
        // =========================================================================
        {
          path: '/change-password',
          name: 'change-password',
          component: () => import('./views/ChangePassword.vue'),
          meta: {
            pageTitle: 'Change Password',
            authRequired: true,
          },
        },
        // =============================================================================
        // Appointment Routes
        // =============================================================================
        {
          path: '/appointment',
          name: 'appointment',
          component: () => import('./views/appointment/AppointmentList.vue'),
          meta: {
            breadcrumb: [{ title: 'Appointment', url: '/' }, { title: 'Appointment' }, { title: 'List', active: true }],
            pageTitle: 'Appointment',
            authRequired: true,
          },
        },
        {
          path: '/appointment/:id',
          name: 'appointment-detail',
          component: () => import('./views/appointment/AppointmentDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Appointment', url: '/appointment' },
              { title: 'Detail', active: true },
            ],
            pageTitle: 'Appointment',
            authRequired: true,
          },
        },
        // =============================================================================
        // Hello DNA Routes
        // =============================================================================
        {
          path: '/hello-dna-profile',
          name: 'hello-dna-profile',
          component: () => import('./views/hello-dna/ProfileList.vue'),
          meta: {
            breadcrumb: [{ title: 'Profile', url: '/' }, { title: 'Hello DNA Profile' }, { title: 'List', active: true }],
            pageTitle: 'Hello DNA Profile',
            authRequired: true,
          },
        },
        {
          path: '/hello-dna-profile/batch-update',
          name: 'hello-dna-profile-batch-update',
          component: () => import('./views/hello-dna/BatchUpdateForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Hello DNA Profile', url: '/hello-dna-profile' },
              { title: 'Batch Update', active: true },
            ],
            pageTitle: 'Hello DNA Profile',
            authRequired: true,
          },
        },
        {
          path: '/hello-dna-profile/:id',
          name: 'hello-dna-profile-edit',
          component: () => import('./views/hello-dna/ProfileForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Hello DNA Profile', url: '/hello-dna-profile' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Hello DNA Profile',
            authRequired: true,
          },
        },
        {
          path: '/hello-dna-disease',
          name: 'hello-dna-disease',
          component: () => import('./views/hello-dna/DiseaseList.vue'),
          meta: {
            breadcrumb: [{ title: 'Disease', url: '/' }, { title: 'Hello DNA Disease' }, { title: 'List', active: true }],
            pageTitle: 'Hello DNA Disease',
            authRequired: true,
          },
        },
        {
          path: '/hello-dna-disease/add',
          name: 'hello-dna-disease-add',
          component: () => import('./views/hello-dna/DiseaseForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Hello DNA Disease', url: '/hello-dna-disease' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Disease',
            authRequired: true,
          },
        },
        {
          path: '/hello-dna-disease/:id',
          name: 'hello-dna-disease-edit',
          component: () => import('./views/hello-dna/DiseaseForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Hello DNA Disease', url: '/hello-dna-disease' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Disease',
            authRequired: true,
          },
        },
        // =============================================================================
        // Advisor Settlement Routes
        // =============================================================================
        {
          path: '/advisor-settlement',
          name: 'advisor-settlement',
          component: () => import('./views/advisor-settlement/AdvisorSettlementList.vue'),
          meta: {
            breadcrumb: [{ title: 'Advisor Settlement', url: '/' }, { title: 'Advisor Settlement' }, { title: 'List', active: true }],
            pageTitle: 'Advisor Settlement',
          }
        },
        {
          path: '/advisor-settlement/:id',
          name: 'advisor-settlement-detail',
          component: () => import('./views/advisor-settlement/AdvisorSettlementDetail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Advisor Settlement', url: '/advisor-settlement' },
              { title: 'Detail', active: true },
            ],
            pageTitle: 'Advisor Settlement',
            authRequired: true,
          }
        },
        // =============================================================================
        // Role Routes
        // =============================================================================
        {
          path: '/admin-role',
          name: 'admin-role',
          component: () => import('./views/admin-role/RoleList.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/' }, { title: 'Admin Role' }, { title: 'List', active: true }],
            pageTitle: 'Admin Roles',
            authRequired: true,
          },
        },
        {
          path: '/admin-role/add',
          name: 'admin-role-add',
          component: () => import('./views/admin-role/RoleForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admin Role', url: '/admin-role' },
              { title: 'Add', active: true },
            ],
            pageTitle: 'Add Admin Role',
            authRequired: true,
          },
        },
        {
          path: '/admin-role/:id',
          name: 'admin-role-edit',
          component: () => import('./views/admin-role/RoleForm.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Admin Role', url: '/admin-role' },
              { title: 'Edit', active: true },
            ],
            pageTitle: 'Edit Admin Role',
            authRequired: true,
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
        },
      ],
    },
    // Display 404 page, if no match found
    {
      path: '*',
      component: () => import('@/views/pages/Error404.vue'),
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.authRequired) {
    if (!store.state.auth.isUserLoggedIn()) {
      router.push({ path: '/login', query: { to: to.path } });
    }
  }
  return next();
});

export default router;
